<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            ref="modal-checkbill"
            @hidden="closeCheckbill"
            v-model="checkBill.show"
            hide-footer
          >
            <template slot="modal-title">
              <div slot="header" class="bg-white border-0">
                <div class="row align-items-center">
                  <div class="col-12">
                    <h3 class="mb-0">ข้อมูลการรับเงิน
                        <span v-if="this.$THEME.name == 'shippop'" @click="goToLinkManual()">
                            <i class="fas fa-info-circle fa-xs text-primary m-1" style="cursor: pointer;" 
                                v-b-tooltip title="คู่มือวิธีการใช้ส่วนลดท้ายบิล">
                            </i>
                        </span>
                    </h3>
                  </div>
                </div>
              </div>
            </template>
            <card shadow type="secondary" class="m--4">
              <template>
                <form @submit.prevent>
                    <div class>
                        <div class="row">
                            <div class="col-lg-12">
                                <div class="group-result">
                                    <div class="price">
                                        <h6>ยอดรวมทั้งหมด</h6>
                                        <h1>
                                            <template v-if="useDiscount"> 
                                                <span class="text-muted number-discount px-2">{{totalPriceOrder | numFormat('0,0.00')}}</span>
                                                <span>{{totalBalance | numFormat('0,0.00')}} </span>
                                            </template>
                                            <template v-else> 
                                                <span>{{totalPriceOrder | numFormat('0,0.00')}} </span>
                                            </template>
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div class="col-lg-12">
                                <div class="row">
                                    <div class="col-lg-5">
                                        <div class="switch-pos">
                                        <div class="d-flex align-items-center">
                                            <b-form-checkbox switch size="lg" v-model="useDiscount" @change="resetDiscount"></b-form-checkbox>
                                            <span>ส่วนลดท้ายบิล</span> 
                                        </div>
                                    </div>
                                    </div>
                                    <div class="col-lg-7">
                                        <b-form-radio-group class="custom-radio-discount" v-if="useDiscount" v-model="typeDiscount" @input="calculatePayment">
                                            <div class="row">
                                                <div class="col-lg-6 px-0" v-for="type in dataTypeDiscount" :key="type.key">
                                                    <b-form-radio :value="type.key">{{type.title}}</b-form-radio>
                                                </div>
                                            </div>
                                           
                                        </b-form-radio-group>
                                    </div>
                                    <div class="col-lg-12 text-right text-muted text-xs" v-if="useDiscount">{{getDiscountTooltip(typeDiscount)}}</div>
                                </div>
                                <div class="price pt-2" v-if="useDiscount">
                                    <h6>ส่วนลด</h6>
                                    
                                    <b-form-input
                                        type="number" 
                                        min="0.00"
                                        placeholder="0"
                                        class="input-discount hide-arrow"
                                        step=".01"
                                        v-model="numDiscount"
                                        :onkeypress="checkMaxDiscount"
                                        @keyup="calculatePayment"
                                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 187'"
                                    >
                                    </b-form-input>
                                    <span>{{getUnit}}</span>
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div class="col-lg-12">
                                <div class="price">
                                    <h6>รับเงิน</h6>
                                    <base-input
                                        formClasses="mb-0"
                                        alternative
                                        typeInput="number"
                                        min="0.00"
                                        v-on:keyup="calculatePayment"
                                        placeholder="0"
                                        input-classes="form-control-alternative hide-arrow"
                                        v-model="checkBill.receiveMoney"
                                        size="lg"
                                        :onkeydown="'return event.keyCode !== 69 && event.keyCode !== 189 && event.keyCode !== 187'"
                                    />
                                </div>
                                <hr class="my-4" />
                            </div>
                            <div class="col-lg-12">
                                <div class="group-result">
                                    <div class="price">
                                        <h6>เงินทอน</h6>
                                        <h1>
                                            {{checkBill.changeMoney | numFormat('0,0.00')}}
                                            <small>บาท</small>
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="mt-4 w-100 text-right">
                        <b-button variant="secondary" @click="closeCheckbill">ยกเลิก</b-button>
                        <b-button
                            type="submit"
                            variant="success"
                            :disabled="(useDiscount) ? totalBalance > checkBill.receiveMoney : totalPriceOrder > checkBill.receiveMoney"
                            @click="$emit('confirmCreateOrder')"
                        >ยืนยัน
                        </b-button>
                    </div>
                </form>
              </template>
            </card>
        </b-modal>
    </div>
</template>

<script>

const TYPE_BAHT = 'BAHT'
const TYPE_PERCENT = 'PERCENT'
const TYPE_BAHT_SHIP = 'BATH_SHIP'
const TYPE_PERCENT_SHIP = 'PERCENT_SHIP'

export default {
    name:'ModalCheckBill',
    props:{
        checkBill: Object,
        totalPriceOrder: Number,
        totalCourierPrice: Number
    },
    data(){
        return{
            useDiscount: false,
            numDiscount: '',
            typeDiscount: TYPE_BAHT,
            dataTypeDiscount:[
                { key: TYPE_BAHT , title: 'บาท', tooltip: 'ส่วนลดทั้งใบเสร็จคิดเป็นบาท'  , unit: 'บาท'},
                { key: TYPE_PERCENT , title: '%', tooltip: 'ส่วนลดทั้งใบเสร็จคิดเป็น %' , unit: '%'},
                { key: TYPE_BAHT_SHIP , title: 'ค่าขนส่ง (บาท)' , tooltip: 'ลดเฉพาะค่าขนส่งไม่รวมสินค้าและค่าบริการพื้นที่ห่างไกล' , unit: 'บาท'},
                { key: TYPE_PERCENT_SHIP , title: 'ค่าขนส่ง (%)' , tooltip: 'ลดเฉพาะค่าขนส่งไม่รวมสินค้าและค่าบริการพื้นที่ห่างไกล' , unit: '%'}
            ]
        }
    },
    methods:{
        getDiscountTooltip(type) {
            let tooltip = ''
            this.dataTypeDiscount.forEach(discount => {
                console.log(discount, type)
                if (type == discount.key) {
                    tooltip = discount.tooltip
                }
            });
            return tooltip
        },
        closeCheckbill() {
            this.checkBill.receiveMoney = "";
            this.checkBill.changeMoney = 0;
            this.checkBill.show = false;
        },
        calculatePayment() {
            if(this.useDiscount && this.totalBalance <= this.checkBill.receiveMoney){ 
                this.checkBill.changeMoney = this.checkBill.receiveMoney - this.totalBalance;
            }else if( !this.useDiscount && this.totalPriceOrder <= this.checkBill.receiveMoney) {
                this.checkBill.changeMoney = this.checkBill.receiveMoney - this.totalPriceOrder;
            } else {
                this.checkBill.changeMoney = 0;
            }

        },
        changeSelectType(){
            this.numDiscount = ''
        },
        resetDiscount(){
            this.typeDiscount = TYPE_BAHT
            this.checkBill.receiveMoney = '';
            this.checkBill.changeMoney = 0
            this.changeSelectType()
        },
        goToLinkManual(){
            window.open(`https://docs.google.com/document/d/1jKw23wtwB-ZUVC84eUqTL8iPe1ZUEQk-xPeS0j3ggmQ/edit?usp=sharing`, '_blank')
        }
    },
    computed: {
        totalBalance(){
            let balance = ''
            if(this.typeDiscount == TYPE_BAHT || this.typeDiscount == TYPE_BAHT_SHIP){
                this.checkBill.discountAmount = this.numDiscount;
                balance = this.totalPriceOrder - this.numDiscount;
            } else if(this.typeDiscount == TYPE_PERCENT_SHIP){
                let discount = this.numDiscount/ 100;
                this.checkBill.discountAmount = (this.totalCourierPrice * discount).toFixed(2);
                balance = Number((this.totalPriceOrder - (this.totalCourierPrice * discount) ).toFixed(2));
            }else{
                let discount = this.numDiscount/ 100;
                this.checkBill.discountAmount = (this.totalPriceOrder * discount).toFixed(2);
                balance = Number((this.totalPriceOrder - (this.totalPriceOrder * discount) ).toFixed(2));
            }
            return balance;
        },
        checkMaxDiscount(){
            if(this.typeDiscount == TYPE_BAHT && this.numDiscount > this.totalPriceOrder){
                this.changeSelectType()
            } else if(this.typeDiscount == TYPE_BAHT_SHIP && this.numDiscount > this.totalCourierPrice){
                this.changeSelectType()
            }else if ( [TYPE_PERCENT, TYPE_PERCENT_SHIP].includes(this.typeDiscount) && this.numDiscount > 100 ){
                this.changeSelectType()
            }
        },
        getUnit(){
            return (this.dataTypeDiscount.find(type => type.key === this.typeDiscount)).unit
        }
    }
}
</script>
<style scoped>
    h1, h2, h3, h4, h5, h6, div {
      color: #000;
    }
    .input-discount{
        max-width: 40%; 
        margin-left: 11rem;
        text-indent:10px;
    }
</style>